const TerminieCondizioniUso = () => {

    const paragrafi = [
        "Le informazioni presenti sul sito sono fornite 'così come sono' senza garanzie di alcun tipo.",
        "Il proprietario del sito non sarà ritenuto responsabile per eventuali danni derivanti dall'uso del sito.",
        "Il sito è destinato esclusivamente ad un uso personale e non commerciale.",
        "Qualsiasi controversia relativa all'uso del sito sarà disciplinata dalla legge italiana.",
    ];

    return (
        <div className="px-4 py-6">
            {/* Titolo Principale */}
            <h1 className="text-3xl font-bold text-center mb-6">Termini e Condizioni d'Uso</h1>

            {/* Sezione Informazioni */}
            <div className="listingSection__wrap">
                <h2 className="text-2xl font-semibold mb-4">L'utilizzo di questo sito è soggetto ai seguenti Termini e Condizioni:</h2>
                {paragrafi.map((testo, index) => (
                    <p
                        key={index}
                        className="text-neutral-6000 dark:text-neutral-300 mb-4"
                    >
                        {testo}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default TerminieCondizioniUso;
